module.exports = __webpack_public_path__ + "img/product_3.5df24a02.jpg";